const getters = {
  receivedDocuments: (state) => state.documents,
  requestedDocuments: (state) => state.requestForm
};

export default {
  getters
};
